// Created by hejikun on 2017/10/25 0025.
let state = {
  home_recommend_doctors_index: [],
  home_recommend_doctors: [], // 推荐医生
  home_my_doctors: [], // 我的医生
  home_courses: [], // 大医生课堂
  home_hasMore: true,
  home_fees: [], // 在线缴费
  home_reports: [] // 报告查询
}

const actions = {
  // 获取首页数据
  loadHomeList({ commit }, args) {
    let url = ''
    switch (args.type) {
      case 'home_recommend_doctors_index': // 推荐医生
        url = `https://newdytapi.ynhdkc.com/index/api/v1/common/askdoctors?page=${args.page}`
        break
      case 'home_recommend_doctors': // 推荐医生
        url = `/index/homepage/askdoctors?page=${args.page}`
        break
      case 'home_my_doctors': // 我的医生
        url = `/index/homepage/myDoctors?page=${args.page}&user_id=${args.user_id}&wechat_id=${args.wechat_id}`
        break
      case 'home_courses': // 大医生课堂
        url = `https://newdytapi.ynhdkc.com/index/api/v1/common/wxclass?page=${args.page}&recommend_value=${args.recommend_value}`
        break
      case 'home_fees': // 在线缴费
        url = `/v1/linefee`
        break
      case 'home_reports': // 报告查询
        url = `/v1/report`
        break
      default:
        return Promise.reject(new Error('请求参数异常'))
    }
    window.axiosBaseApi
      .get(url)
      .then((res) => {
        commit({
          type: 'set_home_list',
          dataType: args.type,
          data: res.data.data,
          page: args.page
        })
        return Promise.resolve(res.data.data)
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  }
}

const getters = {}

const mutations = {
  // 设置首页列表
  set_home_list(state, args) {
    args.data.length < 10 ? (state.home_hasMore = false) : (state.home_hasMore = true)
    if (args.page === 1) {
      if (args.data.length==0) {
        state[args.dataType] = []
      } else {
        state[args.dataType] = args.data
      }
    } else {
      if (args.data.length !== 0) {
        args.data.forEach((item) => {
          state[args.dataType].push(item)
        })
      }
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
